<template>
  <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb">
      
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <!-- 结构问题当前处理方式 通过传值过来 -->
        <router-link :to="parentRouter.path" v-if="index == 0" class="gerey">{{parentRouter.meta}}</router-link>
        <span
          v-if="item.redirect==='noRedirect'||index==levelList.length-1"
          class="no-redirect"
        >{{ item.meta.title }}</span>
        <!-- <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a> -->
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
// import pathToRegexp from 'path-to-regexp'

export default {
  name: "Breadcrumb",
  data() {
    return {
      levelList: null
    };
  },
  props:{
      parentRouter:{
          type:Object,
          default:{}
      } 
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(
        item => item.meta && item.meta.title
      );
      const first = matched[0];
    //   if (!this.isDashboard(first)) {
    //     matched = [{ path: "/dashboard", meta: { title: "Dashboard" } }].concat(
    //       matched
    //     );
    //   }
      this.levelList = matched.filter(
        item => item.meta && item.meta.title 
      );
      // console.log(this.levelList)
    },
    // isDashboard(route) {
    //   const name = route && route.name;
    //   if (!name) {
    //     return false;
    //   }
    //   return (
    //     name.trim().toLocaleLowerCase() === "Dashboard".toLocaleLowerCase()
    //   );
    // }
    // pathCompile(path) {
    //   // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
    //   const { params } = this.$route
    //   var toPath = pathToRegexp.compile(path)
    //   return toPath(params)
    // },
    // handleLink(item) {
    //   const { redirect, path } = item
    //   if (redirect) {
    //     this.$router.push(redirect)
    //     return
    //   }
    //   this.$router.push(this.pathCompile(path))
    // }
  }
};
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 56px;
  margin-left: 8px;
  position: fixed;
  top: 0;
  z-index:100;

  .no-redirect {
    color: #333;
    cursor: text;
  }
  .gerey{
      color: #999;
      font-weight: 400;
  }
}
</style>
<style lang="scss">
/* breadcrumb transition */
.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all .5s;
}

.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-move {
  transition: all .5s;
}

.breadcrumb-leave-active {
  position: absolute;
}

</style>

